// extracted by mini-css-extract-plugin
export var bubble = "_47-0";
export var container = "_47-f";
export var contrastBorder = "_47-g";
export var greyOut = "_47-2";
export var initialsColor0 = "_47-3";
export var initialsColor1 = "_47-4";
export var initialsColor10 = "_47-d";
export var initialsColor11 = "_47-e";
export var initialsColor2 = "_47-5";
export var initialsColor3 = "_47-6";
export var initialsColor4 = "_47-7";
export var initialsColor5 = "_47-8";
export var initialsColor6 = "_47-9";
export var initialsColor7 = "_47-a";
export var initialsColor8 = "_47-b";
export var initialsColor9 = "_47-c";
export var initialsWrapper = "_47-1";
export var large = "_47-l";
export var medium = "_47-k";
export var mediumSmall = "_47-j";
export var mediumSmallMedium = "_47-o";
export var micro = "_47-h";
export var small = "_47-i";
export var tiny = "_47-n";
export var xTiny = "_47-m";